export const environment = {
  prod: false,
  env: 'staging',
  urlPattern: /^(https:\/\/auth.cineri.sn)(\/.*)?$/i,
  
  // Configuration Keycloak
  keycloak: {
    url: 'https://auth.cineri.sn',
    realm: 'sigesr',
    clientId: 'portal-sigesr',
    checkLoginIframe: true,
  },
  
  // URLs des APIs
  api: {
    baseUrl: 'https://api-staging.cineri.sn/api',
    timeout: 30000,
  },
  
  // Options de logging
  logging: {
    level: 'info',
    enableConsole: true,
    enableKeycloakLogs: true,
  },
  
  // Options SSR
  ssr: {
    enabled: true,
    prerender: false,
  },
  
  // Feature flags
  features: {
    enableAnalytics: true,
    enableErrorTracking: true,
  },

  apps: {
    ine: 'https://ine-staging.sigesr.sn',
    campusen: 'https://test.campusen.sn/keycloak/redirect',
    dashboard: 'https://dashboard.sigesr.sn',
    formation: 'https://fmt-staging.campusen.sn/admin',
    habilitation: 'https://sca-staging.sigesr.sn',
    inscription: 'https://insc-staging.sigesr.sn',
    deliberation: 'https://delib-staging.sigesr.sn'
  }
};